// Constantes des noms de collections Firestor
export const COLLECTIONS = {
  INSCALE: "inscale",
};
